import { Contract } from '@definitions/types/symfonyTypes'

import { formatAgeValidationForMessage } from './parseAgeValidation'

/**
 * Returns the display error text for the birthday (date of birth) field.
 * For age validation errors, returns a friendly message with the age scope;
 * otherwise returns the raw validation message.
 */
export function getBirthdayErrorText(
  contract: Contract | undefined,
): string | undefined {
  if (contract?.ageValidation) {
    const scope = formatAgeValidationForMessage(contract.ageValidation)
    const desc = scope || 'mit Altersbeschränkung'
    return `Schade, dieser Tarif ist exklusiv für alle ${desc}. `
  }
  return "Schade, dieser Tarif ist nicht verfügbar. "
}
